import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { ChartDataItem } from "../../utils/chart-values";

interface Eq5dTableProps {
	chartData: ChartDataItem[];
}

export function Eq5dTable({ chartData }: Eq5dTableProps) {
	// Filter out data points with no entries
	const filteredData = chartData.filter((point) => point.entries_count > 0);

	// Calculate average
	const average =
		filteredData.reduce((acc, curr) => acc + (curr.value ?? 0), 0) /
		filteredData.length;

	return (
		<Table>
			<TableHeader>
				<TableRow>
					<TableHead>Time Point</TableHead>
					<TableHead className="text-right">EQ-5D Score</TableHead>
					<TableHead className="text-right">Entries</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{filteredData.map((data) => (
					<TableRow key={data.timing}>
						<TableCell>{data.timing}</TableCell>
						<TableCell className="text-right">
							{data.value !== undefined ? data.value.toFixed(2) : "-"}
						</TableCell>
						<TableCell className="text-right">{data.entries_count}</TableCell>
					</TableRow>
				))}
				<TableRow className="bg-muted/50">
					<TableCell className="font-medium">Average</TableCell>
					<TableCell className="font-medium text-right">
						{average.toFixed(2)}
					</TableCell>
					<TableCell className="text-right">{filteredData.length}</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
}
